import { createTheme, Grid, IconButton, ThemeProvider, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import useStyles from "../../assets/styles";
import { JiraDirectIcon, JiraTitleicon, ServiceNowTitleIcon } from "src/components/Icons";
import { ITSMTitleComponent } from "./ITSMTitleComponent";
import { useHistory } from "react-router-dom";
import { clickBack } from "src/app/utils";
import { hasUserPermission } from "src/app/permission";
import { getJiraProject, getServiceNowProject } from "../components/apiHelper";
import { Loader } from "src/app/setup-senzmatica/step-3/components/Loader";
import { ToasterComponent } from "../components/Toaster";

export const SelectConfiguration = () => {
    const theme = createTheme({
        typography: {
            fontFamily: "'Poppins', sans-serif",
        },
    });
    const classes = useStyles();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [isServiceNowExist, setIsServiceNowExist] = useState(false);
    const [isJiraExist, setIsJiraExist] = useState(false);

    //Toaster
    const [isToasterOpen, setIsToasterOpen] = useState(false)
    const [toasterMessage, setToasterMessage] = useState("")
    const [reqSuccess, setReqSuccess] = useState(false)


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            let errorMessages = [];

            try {
                const serviceNowResponse = await getServiceNowProject();
                if (serviceNowResponse.status === 200 && serviceNowResponse.data.serviceNowBoard != null && serviceNowResponse.data.serviceNowBoard !== "" && serviceNowResponse.data.serviceNowBoard !== undefined) {
                    setIsServiceNowExist(true);
                }
            } catch (serviceNowError) {
                errorMessages.push("Error fetching Service Now Project: " + serviceNowError.message);
            }

            try {
                const jiraResponse = await getJiraProject();
                if (jiraResponse.status === 200 && jiraResponse.data.jiraBoard != null && jiraResponse.data.jiraBoard !== "" && jiraResponse.data.jiraBoard !== undefined) {
                    setIsJiraExist(true);
                }
            } catch (jiraError) {
                errorMessages.push("Error fetching Jira Project: " + jiraError.message);
            }

            setLoading(false);
            
            if (errorMessages.length > 0) {
                setIsToasterOpen(true);
                setReqSuccess(false);
                setToasterMessage(errorMessages.join(' | '));
                setTimeout(() => {
                    setIsToasterOpen(false);
                }, 3000);
            }
        };

        fetchData();
    }, []);

    const handleServiceNowClick = () => {
        if((isServiceNowExist && hasUserPermission("SETUP_DEVICE_PULSE.ITSM_CONFIGURATION.SERVICE_NOW", "VIEW")) || (!isServiceNowExist && hasUserPermission("SETUP_DEVICE_PULSE.ITSM_CONFIGURATION.SERVICE_NOW", "ADD"))) {
            history.push("ServiceNow");
        } else {
            return;
        }        
    };

    const handleJiraClick = () => {
        if((isJiraExist && hasUserPermission("SETUP_DEVICE_PULSE.ITSM_CONFIGURATION.JIRA", "VIEW")) || (!isJiraExist && hasUserPermission("SETUP_DEVICE_PULSE.ITSM_CONFIGURATION.JIRA", "ADD"))) {
            history.push("Jira");
        } else {
            return;
        }
    };
    return (
        <ThemeProvider theme={theme}>
            <div className="testing">
                <ITSMTitleComponent />
                <Grid container className={classes.root} style={{ marginTop: "30px" }}>
                    <Grid item xs={12} md={12} className={classes.itsmFlexContainer}>
                        <Grid item xs={12} md={6}>
                            <div onClick={handleServiceNowClick} style={{ cursor: 'pointer' }}>
                                <Grid container className={classes.selectITSMContainer} style={{height:"190px"}}>
                                    <Grid item xs={12} md={12} className={classes.itsmFlexRowContainer}>
                                        <Grid item xs={4} md={4} className={classes.itsmIcon}>
                                            <ServiceNowTitleIcon />
                                        </Grid>
                                        <Grid item xs={7} md={7} className={classes.itsmFlexColumnContainer}>
                                            <Typography className={classes.itsmTitle}>Servicenow Board</Typography>
                                            <Typography className={classes.itsmSubTitle}>Configure the integration with your ServiceNow instance to allow seamless incident management, real-time updates, and enhanced workflow automation within DevicePulse.</Typography>
                                        </Grid>
                                        <Grid item xs={1} md={1} className={classes.itsmIcon}>
                                            <IconButton>
                                                <JiraDirectIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <div onClick={handleJiraClick} style={{ cursor: 'pointer' }}>
                                <Grid container className={classes.selectITSMContainer} style={{height:"190px"}}>
                                    <Grid item xs={12} md={12} className={classes.itsmFlexRowContainer}>
                                        <Grid item xs={3} md={3} className={classes.itsmIcon}>
                                            <JiraTitleicon />
                                        </Grid>
                                        <Grid item xs={8} md={8} className={classes.itsmFlexColumnContainer}>
                                            <Typography className={classes.itsmTitle}>Jira Board</Typography>
                                            <Typography className={classes.itsmSubTitle}>Set up the integration between DevicePulse and your Jira workspace to enable automated ticket creation, status syncing, and streamlined issue tracking.</Typography>
                                        </Grid>
                                        <Grid item xs={1} md={1} className={classes.itsmIcon}>
                                            <IconButton>
                                                <JiraDirectIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <Loader loading={loading} />
            <ToasterComponent 
                reqSuccess={reqSuccess} 
                message={toasterMessage} 
                toaster={isToasterOpen} 
            />
        </ThemeProvider>

    )
}